function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { addClass, hasClass, removeClass } from "dom-helpers";
import { useCallback, useEffect } from "react";
import { CSSTransitionPortal } from "../Portal";
const timeout = {
    enter: 200,
    exit: 150
};
const BottomSheet = (props)=>{
    const { open , children , onExited  } = props, rest = _objectWithoutProperties(props, [
        "open",
        "children",
        "onExited"
    ]);
    const handleEnter = useCallback(()=>{
        if (hasClass(document.body, "overlay")) return;
        addClass(document.body, "overlay");
    }, []);
    const handleExited = useCallback((element)=>{
        removeClass(document.body, "overlay");
        if (onExited) onExited(element);
    }, [
        onExited
    ]);
    useEffect(()=>{
        return ()=>{
            if (hasClass(document.body, "overlay")) removeClass(document.body, "overlay");
        };
    }, []);
    return /*#__PURE__*/ _jsx(CSSTransitionPortal, _objectSpread({
        open: open,
        timeout: timeout
    }, rest, {
        onEnter: handleEnter,
        onExited: handleExited,
        children: /*#__PURE__*/ _jsx("div", {
            children: children
        })
    }));
};
export default BottomSheet;
